<template>
<transition name="userdropdowntransition" >

<div class="user_dropdown"  v-click-away="hidePanel" v-if="show">
<div class="p-menu p-component p-input-filled" id="overlay_menu">
<ul class="p-menu-list p-reset">
<li class=" text-primary mb-3 mt-3 pl-3 pr-3"><b>{{this.$store.state.auth.user.name}}</b></li>
<li class="p-menu-separator" role="separator"></li>

<li class="p-menuitem test mb-3 mt-3" >
	<a class="p-menuitem-link" role="menuitem" tabindex="0" @click="gotoProfile">
		<span class="p-menuitem-icon pi pi-user"></span>
		<span class="p-menuitem-text">{{$store.state.languages.lang_phrases.profil}}</span>
		<span class="p-ink"></span>
	</a>
</li>
<!--
<li class="p-menuitem test mb-3 mt-3" >
	<a class="p-menuitem-link" role="menuitem" tabindex="0" @click="gotoDisclaimer">
		<span class="p-menuitem-icon pi pi-exclamation-circle"></span>
		<span class="p-menuitem-text">{{$store.state.languages.lang_phrases.yasal_uyari}}</span>
		<span class="p-ink"></span>
	</a>
</li>
-->






<!--
<div class="ml-2 mr-2 mb-3 mt-2">
<Dropdown v-model="$store.state.auth.user.preflang_id" :options="$store.state.languages.languages" optionLabel="name" optionValue="id" class="w-full z-5 "   @change="switchLanguage" />
</div>
-->

<li class="p-menuitem mt-3 mb-3 " @click="logout">
	<a class="p-menuitem-link" role="menuitem" tabindex="0">
		<span class="p-menuitem-icon pi pi-power-off"></span>
		<span class="p-menuitem-text">{{$store.state.languages.lang_phrases.cikis}}</span>
		<span class="p-ink"></span>
	</a>
</li>
</ul>
</div>

</div>
</transition>
</template>

<script>	
export default {

  name: 'UserDropDown',

  data () {
    return {
    	show:false,
    	items: [
                {
                    label:this.$store.state.auth.user.name,
                    items:[
						{
							separator: true,
							label:"separator"
						},
						{
						label: 'Profil',
							icon: 'pi pi-user',
							class:"test"
						},
						{
							label: 'Bildirimler',
							icon: 'pi pi-bell'
						}, 
                    ]
                },
                {
                    separator: true,
                    label:"separator"
                },
                {
                    label: 'Çıkış',
                    icon: 'pi pi-power-off',
                    command: () => {
                       this.logout()
                    }
                },
            ]
    }
  },
  methods:{
  	switchLanguage(event)
  	{
  		console.log(event.value);
  		let formdata = new FormData()      
      	this.silentSubmission(formdata,"user/set_pref_lang/"+event.value,this.afterswitchLanguage)
  	},
  	gotoProfile()
  	{
  		this.hidePanel()
  		this.$router.push({ name: 'User', params: { id:"profile" } })
  	},
  	gotoDisclaimer()
  	{
  		this.$router.push({ name: 'Disclaimer'})
  	},
  	afterswitchLanguage(response)
  	{
  		this.getUserData()
  	},
  	hidePanel()
  	{
  		this.show = false
  	},
  	showPanel()
  	{
  		this.show = true
  	},
  }
};
</script>

<style lang="css" scoped>
</style>